module.exports = __webpack_public_path__ + "img/chris-misterek.07976a83.jpg";